import React from "react";
import { getDsLayoutComponentRenderer } from "@kaltura/mediaspace-shared-layout";

const Kcapture = React.lazy(() => import("@mediaspace/features/kcapture"));

export const render = getDsLayoutComponentRenderer(Kcapture);
